import getPlainText from '@/client/services/richText/getPlainText'
import isSerializedRichTextProbably from '@/client/services/richText/isSerializedRichTextProbably'
import type { SerializedRichText } from '@/client/services/richText/types'

export default class SHWError extends Error {
  externalMessage: string | SerializedRichText

  internalMessage: string

  /**
   * Creates a custom error with optional user-facing and internal messages.
   * @param externalMessage - The message intended to be shown to the user. Optional.
   * @param internalMessage - A more detailed message intended for internal debugging. Optional.
   */
  constructor(
    args: { externalMessage?: string | SerializedRichText; internalMessage?: string } = {}
  ) {
    const externalMessage = args.externalMessage ?? 'An error occurred. Please try again later.'
    const plaintextExternalMessage = isSerializedRichTextProbably(externalMessage)
      ? getPlainText(externalMessage)
      : externalMessage

    super(plaintextExternalMessage)

    this.externalMessage = externalMessage
    this.internalMessage = args.internalMessage ?? plaintextExternalMessage
  }
}
